
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"31","stroke":"#292D32","height":"31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.202 18.51c0 1.666 1.279 3.009 2.867 3.009h3.242c1.383 0 2.506-1.175 2.506-2.622 0-1.576-.684-2.131-1.705-2.493l-5.205-1.808c-1.02-.362-1.705-.918-1.705-2.493 0-1.447 1.124-2.622 2.506-2.622h3.242c1.588 0 2.867 1.343 2.867 3.01M15.5 7.75v15.5","stroke":"inherit","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M15.5 28.417c7.134 0 12.917-5.783 12.917-12.917 0-7.134-5.783-12.917-12.916-12.917-7.134 0-12.917 5.783-12.917 12.917 0 7.134 5.783 12.917 12.917 12.917z","stroke":"inherit","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    